import {
  RoutineFilterColumns,
  RoutineFilterModel,
  useRoutineFilter,
  useSetRoutineFilter,
  useValidateRoutineListOrder,
} from '@gripp/shared-logic';
import {
  ColumnsFilterScreen,
  ColumnsFilterScreenHandle,
  SlideAction,
  useSlideLayout,
  ViewMode,
} from '@gripp/shared-ui';
import { useRef } from 'react';
import { useNavigate } from 'react-router';
import { HeaderResetButton } from '../../shared/components/headerResetButton/headerResetButton';
import { RoutinesBase } from './routines';

export const RoutinesFilterPage = () => {
  const filterRef = useRef<ColumnsFilterScreenHandle>(null);
  const onBackButtonPressRef = useRef<(() => void) | undefined>(undefined);

  const { data: filter } = useRoutineFilter();
  const { mutateAsync: setFilter } = useSetRoutineFilter();
  const validateListOrder = useValidateRoutineListOrder();

  const rightColumn = {
    title: 'routine.list.routines',
    mainComponent: (
      <>
        <ColumnsFilterScreen
          ref={filterRef}
          mode="page"
          filter={filter}
          setFilter={setFilter}
          validateListOrder={validateListOrder}
          createDefaultFilter={() => new RoutineFilterModel()}
          createFilter={(data) => new RoutineFilterModel(data)}
          baseColumns={RoutineFilterColumns}
          adminColumns={['workspace']}
          i18nPrefix="routine.filter"
          viewResultsTranslationKey="common.apply"
          bottomBar={() => <></>}
        />
        <BackHandlerRegistrar onBackButtonPressRef={onBackButtonPressRef} />
      </>
    ),
    headerComponent: (
      <HeaderResetButton onReset={() => filterRef.current?.onReset()} />
    ),
    showBackButton: true,
    onBackButtonPress: () => onBackButtonPressRef.current?.(),
  };

  return <RoutinesBase rightColumn={rightColumn} viewMode={ViewMode.DUAL} />;
};

const BackHandlerRegistrar = ({
  onBackButtonPressRef,
}: {
  onBackButtonPressRef: React.MutableRefObject<(() => void) | undefined>;
}) => {
  const navigate = useNavigate();
  const { onSlideChange } = useSlideLayout();

  onBackButtonPressRef.current = async () => {
    await onSlideChange(SlideAction.SINGLE);
    navigate('/new-routines');
  };

  return null;
};
